import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  writeWorkspaceSearchParams,
  type WorkspaceSearchUrlState,
} from "@/lib/navigation/workspaceSearchParams";

/**
 * Keeps the address of the Workspaces page in step with its search (LAR-235), so the
 * browser's back button and "Tilbage" from a document opened from the results return to
 * the same search. Replaces the history entry instead of adding one per keystroke.
 */
export const useWorkspaceSearchAddress = (
  state: WorkspaceSearchUrlState
): void => {
  const location = useLocation();
  const navigate = useNavigate();
  const { search, resultType, zoomedWorkspaceId, zoomedFrom } = state;

  useEffect(() => {
    const params = writeWorkspaceSearchParams(
      new URLSearchParams(location.search),
      { search, resultType, zoomedWorkspaceId, zoomedFrom }
    );
    const query = params.toString();
    const nextSearch = query ? `?${query}` : "";
    if (nextSearch === location.search) return;
    navigate(
      { pathname: location.pathname, search: nextSearch },
      { replace: true, state: location.state }
    );
  }, [
    search,
    resultType,
    zoomedWorkspaceId,
    zoomedFrom,
    location.pathname,
    location.search,
    location.state,
    navigate,
  ]);
};
